<template>
	<div class="add-user-machine-group">
		<el-dialog
			:modal-append-to-body="true"
			:append-to-body="true"
			:title="userMachineGroup.id ? 'Edit device label' : 'New device label'"
			:visible.sync="localDialogVisible"
			width="60%"
			top="9vh"
			@closed="closeDialog"
			@open="openDialog"
			:close-on-click-modal="false">
			<div v-loading="loadingForm" :element-loading-text="$t('common.request')">
				<el-form
					:label-position="labelPosition"
					:rules="rules"
					ref="userMachineGroup"
					label-width="80px"
					:model="userMachineGroup">
					<el-row :gutter="20">
						<el-col :span="8">
							<el-form-item label="Label name" prop="name">
								<el-input
									v-model="userMachineGroup.name"
									placeholder="请输入设备标签名称"
									autocomplete="off"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<!-- 添加 -->
					<el-row :gutter="20" v-if="!userMachineGroup.id">
						<el-col :span="24">
							<el-tag type="info">{{
								$t("addUserMachineGroup.noList")
							}}</el-tag>
							<el-table
								v-el-table-infinite-scroll="loadAddUnSelect"
								v-loading="loading"
								:empty-text="$t('common.noData')"
								:element-loading-text="$t('common.loading')"
								height="350px"
								:data="unselectList"
								style="width: 100%; margin-top: 10px"
								@selection-change="unselect">
								<el-table-column type="selection" width="55"></el-table-column>
								<el-table-column
									prop="equipmentNo"
									:show-overflow-tooltip="true"
									:label="
										$t('addUserMachineGroup.equipmentNo')
									"></el-table-column>
								<el-table-column
									prop="name"
									:label="$t('addUserMachineGroup.equipmentName')"
									:show-overflow-tooltip="true"></el-table-column>
							</el-table>
						</el-col>
					</el-row>
					<el-row :gutter="20" v-else>
						<el-col :span="12">
							<el-tag type="info">{{
								$t("addUserMachineGroup.noList")
							}}</el-tag>
							<el-button
								type="primary"
								class="right"
								v-if="userMachineGroup.id"
								size="small"
								icon="el-icon-plus"
								:disabled="unselectChangeList.length <= 0"
								@click="addMachine(1)"
								>{{ $t("addUserMachineGroup.addM") }}</el-button
							>
							<el-table
								v-loading="loading"
								v-el-table-infinite-scroll="loadEditUnSelect"
								:empty-text="$t('common.noData')"
								:element-loading-text="$t('common.loading')"
								:data="unselectList"
								height="350px"
								style="width: 100%; margin-top: 10px"
								@selection-change="unselect">
								<el-table-column type="selection" width="55"></el-table-column>
								<el-table-column
									prop="equipmentNo"
									:show-overflow-tooltip="true"
									:label="
										$t('addUserMachineGroup.equipmentNo')
									"></el-table-column>
								<el-table-column
									prop="name"
									:label="$t('addUserMachineGroup.equipmentName')"
									:show-overflow-tooltip="true"></el-table-column>
							</el-table>
						</el-col>
						<el-col :span="12">
							<el-tag type="info">{{
								$t("addUserMachineGroup.yesList")
							}}</el-tag>
							<el-button
								type="danger"
								class="right"
								size="small"
								v-if="userMachineGroup.id"
								icon="el-icon-delete"
								:disabled="selectChangeList.length <= 0"
								@click="addMachine(0)"
								>{{ $t("addUserMachineGroup.remM") }}</el-button
							>
							<el-table
								v-loading="loadingSelect"
								v-el-table-infinite-scroll="loadEditSelect"
								:empty-text="$t('common.noData')"
								:element-loading-text="$t('common.loading')"
								:data="selectList"
								height="350px"
								style="width: 100%; margin-top: 10px"
								@selection-change="select">
								<el-table-column type="selection" width="55"></el-table-column>
								<el-table-column
									prop="equipmentNo"
									:show-overflow-tooltip="true"
									:label="
										$t('addUserMachineGroup.equipmentNo')
									"></el-table-column>
								<el-table-column
									prop="name"
									:label="$t('addUserMachineGroup.equipmentName')"
									:show-overflow-tooltip="true"></el-table-column>
							</el-table>
						</el-col>
					</el-row>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancel('')">{{ $t("common.cancel") }}</el-button>
				<el-button
					type="primary"
					:disabled="loadingForm"
					@click="submitForm('userMachineGroup')"
					>{{ $t("common.definite") }}</el-button
				>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import elTableInfiniteScroll from "el-table-infinite-scroll";

export default {
	directives: {
		"el-table-infinite-scroll": elTableInfiniteScroll,
	},
	name: "AddUserMachineGroup",
	props: {
		dialogUserMachineGroup: Boolean,
		userMachineGroup: Object,
	},
	data() {
		return {
			labelPosition: "top",
			localDialogVisible: this.dialogUserMachineGroup,
			rules: {
				name: [
					{
						required: true,
						message: this.$t("addUserMachineGroup.pName"),
						trigger: "blur",
					},
				],
			},
			clear: false,
			loading: false,
			userMachineList: [],
			unselectList: [],
			selectList: [],
			unselectChangeList: [],
			selectChangeList: [],
			addUnSelect: {
				loading: false,
				page: {
					pageSize: 10,
					pageIndex: 1,
					pages: 1,
				},
			},
			editUnSelect: {
				loading: false,
				page: {
					pageSize: 10,
					pageIndex: 1,
					pages: 1,
				},
			},
			editSelect: {
				loading: false,
				page: {
					pageSize: 10,
					pageIndex: 1,
					pages: 1,
				},
			},
			loadingSelect: false,
			loadingForm: false,
		};
	},
	watch: {
		dialogUserMachineGroup(val) {
			this.localDialogVisible = val;
		},
	},
	mounted() {
		this.clear = false;
	},
	methods: {
		buildSelectPageParams(page, extra = {}) {
			return {
				...extra,
				pageIndex: page.pageIndex,
				pageSize: page.pageSize,
			};
		},
		// 弹窗关闭事件
		closeDialog() {
			this.clearValidate("userMachineGroup");
			if (this.userMachineGroup.id) {
				this.$toolUtil.clearForm(this.userMachineGroup);
			} else {
				if (this.clear) {
					this.$toolUtil.clearForm(this.userMachineGroup);
				}
			}
			this.cancel("");
		},
		// 弹窗打开事件
		openDialog() {
			this.unselectList = [];
			this.selectList = [];
			this.addUnSelect.page.pageIndex = 1;
			this.editSelect.page.pageIndex = 1;
			this.editUnSelect.page.pageIndex = 1;
			if (this.userMachineGroup.id) {
				this.loadEditSelect();
				this.loadEditUnSelect();
			} else {
				this.loadAddUnSelect();
			}
		},
		// 关闭弹窗
		cancel(state, code) {
			this.$emit("cancel", false, state, code);
		},
		// 提交创建分组表单
		submitForm(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					this.loadingForm = true;
					let url = this.$url.UserMachineLabels.insert;
					let method = this.$method.post;
					if (this.userMachineGroup.id) {
						url = this.$url.UserMachineLabels.update;
						method = this.$method.put;
					}
					//   添加机器id
					this.userMachineGroup.userEquipmentId = this.$cloud.getIds(
						this.selectList
					);

					if (!this.userMachineGroup.id) {
						// 如果是新增
						this.userMachineGroup.userEquipmentId = this.unselectChangeList.map(
							item => item.id
						);
					}

					this.$api
						.request(url, method, this.userMachineGroup)
						.then(res => {
							if (res.code === 0) {
								this.$notify({
									title: this.$t("common.tip"),
									message: res.msg,
									type: "success",
								});
								this.cancel(this.userMachineGroup.id ? "update" : "save");
							}
							this.loadingForm = false;
						})
						.catch(err => {
							this.$notify({
								title: this.$t("common.tip"),
								message: err.msg,
								type: "error",
							});
							this.loadingForm = false;
						});
				}
			});
		},
		// 清除表单校验
		clearValidate(formName) {
			this.$refs[formName].clearValidate();
		},
		// 已添加设备分组全选触发事件
		select(val) {
			this.selectChangeList = val;
		},
		// 未添加分组设备全选触发事件
		unselect(val) {
			this.unselectChangeList = val;
		},
		// 滚动加载未添加分组设备
		loadAddUnSelect() {
			if (
				!this.addUnSelect.loading &&
				this.addUnSelect.page.pages >= this.addUnSelect.page.pageIndex
			) {
				this.addUnSelect.loading = true;
				this.loading = true;
				this.$api
					.request(
						this.$url.UserMachineLabels.choosePage,
						this.$method.get,
						this.buildSelectPageParams(this.addUnSelect.page, { type: 0 })
					)
					.then(res => {
						if (res.code === 0 && res.data.records.length > 0) {
							this.unselectList = this.unselectList.concat(res.data.records);
							this.addUnSelect.page.pages = parseInt(res.data.pages);
							this.addUnSelect.page.pageIndex =
								this.addUnSelect.page.pageIndex + 1;
						}
						this.addUnSelect.loading = false;
						this.loading = false;
					})
					.catch(() => {
						this.addUnSelect.loading = false;
						this.loading = false;
					});
			}
		},
		// 滚动加载未添加分组设备
		loadEditUnSelect() {
			if (
				!this.editUnSelect.loading &&
				this.editUnSelect.page.pages >= this.editUnSelect.page.pageIndex
			) {
				this.editUnSelect.loading = true;
				this.loading = true;
				this.$api
					.request(
						this.$url.UserMachineLabels.choosePage,
						this.$method.get,
						this.buildSelectPageParams(this.editUnSelect.page, { type: 2 })
					)
					.then(res => {
						if (res.code === 0 && res.data.records.length > 0) {
							this.unselectList = this.unselectList.concat(res.data.records);
							this.editUnSelect.page.pages = parseInt(res.data.pages);
							this.editUnSelect.page.pageIndex =
								this.editUnSelect.page.pageIndex + 1;
						}
						this.editUnSelect.loading = false;
						this.loading = false;
					})
					.catch(() => {
						this.editUnSelect.loading = false;
						this.loading = false;
					});
			}
		},
		// 滚动加载已添加分组设备
		loadEditSelect() {
			if (
				!this.editSelect.loadingSelect &&
				this.editSelect.page.pages >= this.editSelect.page.pageIndex
			) {
				this.editSelect.loadingSelect = true;
				this.loading = true;
				this.$api
					.request(
						this.$url.UserMachineLabels.choosePage +
							"?labelTeamId=" +
							this.userMachineGroup.id,
						this.$method.get,
						this.buildSelectPageParams(this.editSelect.page)
					)
					.then(res => {
						if (res.code === 0 && res.data.records.length > 0) {
							this.selectList = this.selectList.concat(res.data.records);
							this.editSelect.page.pages = parseInt(res.data.pages);
							this.editSelect.page.pageIndex =
								this.editSelect.page.pageIndex + 1;
						}
						this.editSelect.loadingSelect = false;
						this.loading = false;
					})
					.catch(() => {
						this.editSelect.loadingSelect = false;
						this.loading = false;
					});
			}
		},
		// 修改设备到分组
		addMachine(type) {
			if (
				(type === 1 && this.unselectChangeList.length > 0) ||
				(type === 0 && this.selectChangeList.length > 0)
			) {
				if (type === 1) {
					this.userMachineGroup.userEquipmentIds = this.$cloud.getIds(
						this.unselectChangeList
					);
				} else {
					this.userMachineGroup.userEquipmentIds = this.$cloud.getIds(
						this.selectChangeList
					);
				}
				this.userMachineGroup.type = type;
				this.$api
					.request(
						this.$url.UserMachine.updateLabelId,
						this.$method.put,
						this.userMachineGroup
					)
					.then(res => {
						if (res.code === 0) {
							this.$notify({
								title: this.$t("common.tip"),
								message: res.msg,
								type: "success",
							});
							this.editSelect.page.pageIndex = 1;
							this.editUnSelect.page.pageIndex = 1;
							this.selectList = [];
							this.unselectList = [];
							this.loadEditUnSelect();
							this.loadEditSelect();
						}
					})
					.catch(err => {
						this.$notify({
							title: this.$t("common.tip"),
							message: err.msg,
							type: "error",
						});
					});
			}
		},
		// 移除设备分组
		delMachine() {
			if (this.selectChangeList.length > 0) {
				this.userMachineGroup.userEquipmentIds = this.$cloud.getIds(
					this.selectChangeList
				);
				this.userMachineGroup.type = 1;
				this.$api
					.request(
						this.$url.UserMachine.updateLabelId,
						this.$method.put,
						this.userMachineGroup
					)
					.then(res => {
						if (res.code === 0) {
							this.$notify({
								title: this.$t("common.tip"),
								message: res.msg,
								type: "success",
							});
						}
					})
					.catch(err => {
						this.$notify({
							title: this.$t("common.tip"),
							message: err.msg,
							type: "error",
						});
					});
			}
		},
	},
};
</script>

<style scoped>
.right {
	float: right;
}
</style>
